<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="server-section doc-wrapper doc-inner">
    <div class="row">
        <div class="col-xl-12">
            <div class="server-wrapper">
                <h2 class="inner-title">Server Setup and Installation Guide</h2>
                <h5>Follow these steps to set up and install the website and admin panel on your server:</h5>
                <ul class="configure-list">
                    <li><b>Step 1:</b> Upload Files</li>
                    <ul class="custom-list">
                        <li><strong>Download and Upload :</strong> After downloading the code from Codecanyon, upload the <code>[project name]-web-[version number].zip</code> file to your server using your preferred method, such as FTP or through your hosting provider’s file manager.</li>
                        <div class="row">
                            <div class="col-xl-7">
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/file_manager.webp" alt="server">
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-7">
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/file_upload.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/select_file.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/uploading.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/uploaded.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/file_extract.webp" alt="server">
                                </a>
                            </div>
                        </div>
                        <li><strong>Extract Files :</strong> Extract the contents of the <code>[project name]-web-[version number].zip</code> file in your desired directory. This directory will serve as the root for your website and admin panel.</li>
                        <div class="row">
                            <div class="col-xl-7">
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/extract_file_directory.webp" alt="server">
                                </a>
                            </div>
                        </div>
                    </ul>
                    <li><b>Step 2:</b> Create MySQL Database</li>
                    <ul class="custom-list">
                        <li><strong>Login to cPanel :</strong> Access your cPanel account provided by your hosting provider.</li>
                        <li><strong>Navigate to MySQL Database :</strong> Locate and access the MySQL Database section in your cPanel.</li>
                        <li><strong>Create Database :</strong> Create a new MySQL database and note down the database name, username, and password. You’ll need these details during the installation process.</li>
                        <div class="row">
                            <div class="col-xl-7">
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/database.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/create_database.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/create_user_database.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/add_user_database.webp" alt="server">
                                </a>
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/user_permission_database.webp" alt="server">
                                </a>
                            </div>
                        </div>
                    </ul>
                    <li><b>Step 3:</b> Installation</li>
                    <ul class="custom-list">
                        <li><strong>Run Installation Script :</strong> Run your domain URL in a web browser. You’ll be prompted with the installation steps. Follow the instructions carefully.</li>
                        <li><strong>Start Installation :</strong> Click the “Start” button to initiate the installation process.</li>
                        <div class="row">
                            <div class="col-xl-7">
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/start_installation.webp" alt="server">
                                </a>
                            </div>
                        </div>
                        <li><strong>Follow Instructions :</strong> Follow each step of the installation wizard, providing necessary information when prompted, such as database connection details.</li>
                        <li><strong>Complete Installation :</strong> Once all steps are completed successfully, you’ll receive a confirmation message indicating that the installation is complete.</li>
                        <div class="row">
                            <div class="col-xl-7">
                                <a class="img-popup">
                                    <img src="/product/efunding/documentation/assets/images/serverConfiguration/installation_done.webp" alt="server">
                                </a>
                            </div>
                        </div>
                    </ul>
                    <p><b class="text--danger">Conclusion:</b> Congratulations! You have successfully set up and installed the website and admin panel on your server. You can now access and manage your website through your domain. If you encounter any issues during the installation process, refer to the documentation provided or seek assistance from your hosting provider. Enjoy using your new website and admin panel!</p>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'ServerSetupRequirements'}" class="left"><i class="las la-angle-left me-1"></i> Server Setup Requirements</router-link>
        <router-link :to="{ name: 'AdminPanelSetup'}" class="right">Admin Panel Setup <i class="las la-angle-right ms-1"></i></router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>

<script>
export default {
    name: 'ServerConfigurationPage',
}
</script>